var map = {
	"./browser-notice.de-CH.json": 1002,
	"./browser-notice.de-DE.json": 1003,
	"./browser-notice.en-CA.json": 1004,
	"./browser-notice.en-GB.json": 1005,
	"./browser-notice.en-IN.json": 1006,
	"./browser-notice.en-ME.json": 1007,
	"./browser-notice.en-US.json": 1008,
	"./browser-notice.es-EM.json": 1009,
	"./browser-notice.es-ES.json": 1010,
	"./browser-notice.fr-BE.json": 1011,
	"./browser-notice.fr-CA.json": 1012,
	"./browser-notice.fr-CH.json": 1013,
	"./browser-notice.nl-BE.json": 1014,
	"./browser-notice.nl-NL.json": 1015,
	"./browser-notice.pl-PL.json": 1016,
	"./browser-notice.pt-BR.json": 1017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1001;